import { reactive, readonly } from 'vue';
import { inventoryDocumentsApi } from '@/services/inventory';
import { authStore } from './auth';
import { warehouseStore } from './warehouse';

// The count on the sidebar's "Phiếu nhập" badge (design handoff §0): phiếu that
// have left Nháp but not yet been ghi sổ — printed and waiting for signatures,
// or signed and waiting for Xác nhận. Those are the ones sitting on the desk;
// a Nháp is still being written and a Đã xác nhận is finished, so neither is
// something the operator is being asked to come back to.
//
// Two reads with `page_size: 1`, for `meta.total` only — the badge needs a
// number, not the rows. It is deliberately *not* refreshed on every navigation:
// the pages that change these statuses call `refresh()` themselves, which is
// both cheaper and more accurate than polling.
const PENDING_STATUSES = ['PRINTED', 'SIGNED'];
const state = reactive({ count: 0 });

export const pendingReceiptsStore = {
  state: readonly(state),
  async refresh() {
    // Someone without `documents.view` gets a 403 on every one of these; the
    // badge simply has nothing to say for them.
    if (!authStore.hasPermission('documents.view')) { state.count = 0; return 0; }
    try {
      const totals = await Promise.all(PENDING_STATUSES.map((status) => inventoryDocumentsApi
        .list({ type: 'RECEIPT', status, warehouse_id: warehouseStore.state.selectedId || undefined, page: 1, page_size: 1 })
        .then((response) => response.meta?.total || 0)));
      state.count = totals.reduce((sum, total) => sum + total, 0);
    } catch (_) {
      // A badge is a hint. Failing to read it must never surface an error over
      // whatever screen the operator is actually working on.
      state.count = 0;
    }
    return state.count;
  },
  reset() { state.count = 0; },
};
